<template>
  <div class="account-setting">
    <gat-head></gat-head>
    <div class="account-center">
      <div class="account-block">
        <h3 class="title"><i></i>个人资料</h3>
        <div class="box clearfix">
          <div class="data-left">
            <div class="avatar" @click="uploadAvatarActive">
              <img
                :src="
                  account.photo
                    ? /^(https?:\/\/)/.test(account.photo)
                      ? account.photo
                      : photoBaseUrl + account.photo
                    : placeholder.uploadAvater
                "
                alt
              />
            </div>
            <p>仅支持JPG、JPEG格式，文件小于1M</p>
          </div>
          <div class="data-right">
            <el-form ref="userInfoForm" :model="account" label-width="120px">
              <el-form-item label="角色" class="marginBottom">
                <span>{{ account.roleName }}</span>
              </el-form-item>
              <el-form-item label="性别">
                <el-radio-group v-model="account.sex">
                  <el-radio
                    v-for="item in sexRadio"
                    :label="item.label"
                    :key="item.label"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="昵称">
                <el-input
                  v-model.trim="account.nickName"
                  maxlength="20"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="QQ">
                <el-input
                  v-model.trim="account.qq"
                  maxlength="20"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="个性签名">
                <!-- :rows="3"
                  maxlength="100"
                  v-model.trim="account.resume" -->
                <el-input
                  type="textarea"
                  v-model="account.resume"
                  id="personal-signature"
                  :rows="3"
                  maxlength="100"
                  v-model.trim="account.resume"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="function">
              <el-button type="primary" @click="personInfoSave">保存</el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="account-block">
        <h3 class="title">
          <i></i>更多信息
          <div class="see">
            <el-checkbox
              v-if="false"
              v-model="account.IsPublic"
              :true-label="1"
              :false-label="0"
              @change="personInfoSave('IsPublic')"
            >
              所有人可见
            </el-checkbox>
          </div>
        </h3>

        <div class="box clearfix more-information">
          <el-form ref="moreInfoForm" :model="account" label-width="70px">
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item label="真实姓名">
                  <el-input
                    v-model.trim="account.realName"
                    maxlength="20"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所在学校">
                  <el-input
                    v-model.trim="account.school"
                    maxlength="30"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item label="所在专业">
                  <!-- :disabled="true"  @change="moreInfoSave('ScoolName')"-->
                  <!--<el-input v-model.trim="account.Major"></el-input>-->
                  <el-input
                    v-model.trim="account.major"
                    maxlength="30"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12"></el-col>
            </el-row>
          </el-form>

          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
          <el-row>
            <div class="function">
              <el-button type="primary" @click="personInfoSave">保存</el-button>
            </div>
          </el-row>
        </div>
      </div>

      <div class="account-block">
        <h3 class="title"><i></i>主账号</h3>
        <div class="box clearfix">
          <ul class="account">
            <li>
              <label>密码</label>
              <!-- <span v-if="!account.Password">未设置密码</span> -->
              <el-button type="primary" @click="activePopup('password')"
                >设置密码</el-button
              >
            </li>
            <li>
              <label>手机号</label>
              <span class="binding" v-if="account.mobile">已绑定手机号</span>
              <span class="unbing" v-else>未绑定手机号</span>
              <el-button
                type="primary"
                :plain="!!account.mobile"
                @click="telEmailBind('mobile', account.mobile)"
                >{{ account.mobile ? '更换绑定' : '绑定手机' }}</el-button
              >
            </li>
            <li>
              <label>邮箱号</label>
              <span class="binding" v-if="account.email">已绑定邮箱</span>
              <span class="unbing" v-else>未绑定邮箱</span>
              <el-button
                type="primary"
                :plain="!!account.email"
                @click="telEmailBind('email', account.email)"
                >{{ account.email ? '解除绑定' : '绑定邮箱' }}</el-button
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 头像上传 -->
      <gat-popup
        :class="['popup-avatar', popupActive === 'avatar' ? 'on' : 'off']"
        ref="popupAvatar"
        :title="'头像上传'"
        @cancel="cancelPopup('passwordForm', $event)"
        @confirm="submitAvater"
      >
        <template v-slot:content>
          <!-- TODO: -->
          <div class="crop-wrap">
            <div class="cropper-box">
              <Cropper
                class="cropper"
                :src="avatar.url"
                :stencil-props="{
                  aspectRatio: 1 / 1,
                }"
                :imageRestriction="'area'"
                ref="cropper"
                @change="crop"
              ></Cropper>

              <div class="btn-again">
                <el-button type="text" @click="inputFileVirtual().click()"
                  >再次上传</el-button
                >
              </div>
            </div>

            <div class="preview">
              <img :src="avatar.image" alt />
            </div>
          </div>
        </template>
        <!-- <template v-slot:buttons> -->
        <!-- <span></span> -->
        <!-- </template> -->
      </gat-popup>
      <!-- 密码设置 -->
      <gat-popup
        :class="['popup-password', popupActive === 'password' ? 'on' : 'off']"
        ref="popupPassword"
        :title="'设置密码'"
        primaryButton="保存"
        primaryWidth="100%"
        cancelButton="false"
        @cancel="cancelPopup('passwordForm', $event)"
        @confirm="submitSetting"
      >
        <template v-slot:content>
          <!--  label-width="8em"-->
          <el-form
            class="password-form"
            ref="passwordForm"
            :model="passwordForm"
            :rules="rules"
          >
            <el-form-item prop="jpass">
              <el-input
                type="password"
                v-model.trim="passwordForm.jpass"
                autofocus
                show-password
                autocomplete="off"
                placeholder="原密码"
              ></el-input>
            </el-form-item>
            <!-- label="新密码：" -->
            <el-form-item prop="pass">
              <el-input
                type="password"
                v-model.trim="passwordForm.pass"
                autofocus
                show-password
                @input="varifyPassSet"
                autocomplete="off"
                placeholder="新密码：8-20位密码，区分大小写"
              ></el-input>
            </el-form-item>

            <div class="pass-show-wrap">
              <span :class="[passStatus ? 'weak' : '']"></span>
              <span
                :class="[
                  passStatus == 'medium' || passStatus == 'strong'
                    ? 'medium'
                    : '',
                ]"
              ></span>
              <span :class="[passStatus == 'strong' ? 'strong' : '']"></span>
              <p>密码强度</p>
            </div>

            <el-form-item prop="checkPass">
              <el-input
                type="password"
                v-model.trim="passwordForm.checkPass"
                autofocus
                show-password
                autocomplete="off"
                placeholder="确认新密码：8-20位密码，区分大小写"
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>
      <!-- 电话、邮箱绑定 -->
      <gat-popup
        :class="[
          popupActive === 'mobile' ? 'popup-tel-mobile' : 'popup-tel-email',
          popupActive === 'mobile' || popupActive === 'email' ? 'on' : 'off',
        ]"
        ref="popupTelEmail"
        :title="'绑定'"
        @cancel="cancelPopup('telEmailForm', $event)"
        @confirm="submitBinding(popupActive)"
      >
        <template v-slot:content>
          <el-form
            class="tel-email-form"
            ref="telEmailForm"
            label-width="7em"
            :model="telEmailForm"
            :rules="telemailRules[popupActive]"
          >
            <el-form-item
              label="手机号："
              prop="mobile"
              v-if="popupActive == 'mobile'"
            >
              <el-input
                class="mobile-input"
                type="text"
                v-model.trim="telEmailForm.mobile"
                oninput ="value=value.replace(/[^\d]/g,'')" 
                @blur="telEmailForm.mobile=$event.target.value" 
                placeholder=""
                maxlength="11"
              ></el-input>
              <!-- <el-button
                v-if="!codeText"
                type="primary"
                size="small"
                @click="onGetCode"
                >获取验证码</el-button
              >
              <el-button v-else type="primary" size="small"
                >{{ codeText }} 秒</el-button
              > -->
            </el-form-item>
            <!-- <el-form-item
              label="新手机号："
              prop="newMobile"
              v-if="popupActive == 'mobile'"
            >
              <el-input type="text" v-model.trim="telEmailForm.newMobile"></el-input>
            </el-form-item> -->
            <!-- <el-form-item
              label="验证码："
              prop="code"
              v-if="popupActive == 'mobile'"
            >
              <el-input type="text" v-model.trim="telEmailForm.code"></el-input>
            </el-form-item> -->
            <el-form-item
              label="邮箱："
              prop="email"
              v-if="popupActive == 'email'"
            >
              <el-input
                type="text"
                v-model.trim="telEmailForm.email"
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import COMMON from '@/axios/common/common.js'
import ACCOUNTSRTTING from '@/axios/AccountSetting/AccountSetting.js'

import GatFooter from '@/components/common/GatFooter.vue'
import GatPopup from '@/components/common/GatPopup'
// 头像剪切和编辑插件
import { Cropper } from 'vue-advanced-cropper'
import { GetVerifyImgs } from '@/assets/js/mixin/mixinGetVerifyImgs.js'

export default {
  name: 'account-setting',
  mixins: [GetVerifyImgs],
  components: { /*GatFooter,*/ GatPopup, Cropper },
  data() {
    // el-form 自定义校验，一定要有返回 callback
    // 原密码校验
    var validateJPass = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请输入原密码'))
      } else {
        callback()
      }
    }
    // 新密码校验
    var validatePass = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请输入新密码'))
      } else {
        // TODO:格式校验
        let passStatus = this.passStatus
        let pas_match = /^(?![\d]+$)(?![a-zA-Z]+$)(?![!#$%^&*]+$)[\da-zA-Z._~!@#$^&*]{8,20}$/ //验证密码
        let match = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,20}$/ // 验证字母+数字
        if (/[\s|\u4e00-\u9fa5].*/.test(value)) {
          callback(new Error('不能使用空格、中文'))
        } else if (value.length < 8 || value.length > 20) {
          callback(new Error('长度为8-20个字符'))
        } else if (!match.test(value)) {
          callback(new Error('密码由8-20位的数字和字母组合'))
        } else {
          this.$refs.passwordForm.validateField('checkPass')
          callback()
        }
        // if (this.passwordForm.checkPass !== "") {
        // if (/[\s|\u4e00-\u9fa5].*/.test(value)) {
        //   callback(new Error('不能使用空格、中文'))
        // } else if (value.length < 8 || value.length > 20) {
        //   callback(new Error('长度为8-20个字符'))
        // } else if (!this.passStatus) {
        //   callback(new Error('不能含有非法字符'))
        // } else {
        //   this.$refs.passwordForm.validateField('checkPass')
        //   callback()
        // }
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    var validTel = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请输入手机号'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
    }
    var validTel2 = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请输入新手机号'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
    }

    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      tenantId: '',
      account: {},
      // 性别 1:男;2:女 ,
      sexRadio: [
        {
          label: '10',
          name: '男',
        },
        {
          label: '20',
          name: '女',
        },
      ],
      placeholder: {
        uploadAvater: require('../../public/images/img16.png'),
      },
      infoForm: {
        name: '',
        school: '',
        profession: '',
        IsPublic: 0, // 账号信息是否公开：0 否  1 是
      },
      // 弹窗标记
      popupActive: '',
      avatar: {
        url: '',
        file: null,
        image: null,
        coordinates: {
          width: 0,
          height: 0,
          left: 0,
          top: 0,
        },
      },
      telEmailForm: {
        mobile: '',
        newMobile: '',
        code: '',
        email: '',
      },
      codeText: null,
      codeTime: null,
      passwordForm: {
        jpass: '',
        pass: '',
        checkPass: '',
      },
      passStatus: null, //设置密码的验证状态
      // 验证规则
      rules: {
        jpass: [
          {
            validator: validateJPass,
            trigger: 'blur',
          },
        ],
        pass: [
          {
            validator: validatePass,
            trigger: 'blur',
          },
        ],
        checkPass: [
          {
            validator: validatePass2,
            trigger: 'blur',
          },
        ],
      },
      telemailRules: {
        mobile: {
          // 绑定手机弹窗检验
          mobile: [
            { required: true, message: '请输入手机号码' },
            { trigger: 'blur', validator: validTel },
          ],
          newMobile: [
            { required: true, message: '请输入新手机号码' },
            { trigger: 'blur', validator: validTel2 },
          ],
          code: [{ required: true, message: '请输入短信验证码' }],
        },
        email: {
          // 绑定邮箱弹窗检验
          email: [
            { required: true, message: '邮箱不能为空' },
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur', 'change'],
            },
          ],
        },
      },
    }
  },
  computed: {
    token() {
      return this.$store.state.token
    },
    accountInfo() {
      return this.$store.state.accountInfo
    },
  },
  watch: {},
  created() {
    this.getUser()
  },
  mounted() {},
  methods: {
    // 获取用户信息
    getUser() {
      ACCOUNTSRTTING.getUserInfo().then((response) => {
        // console.log('获取用户信息', response)
        if (response.isSuccess) {
          let obj = JSON.parse(JSON.stringify(response.data))
          this.tenantId = obj.tenantId
          let accountInfo = this.$store.state.accountInfo
          accountInfo = { ...accountInfo, ...obj }
          this.$store.state.accountInfo = accountInfo
          sessionStorage.accountInfo = JSON.stringify(accountInfo)
          this.account = JSON.parse(JSON.stringify(accountInfo))
          if (
            this.account &&
            this.account.roleRes[0] &&
            this.account.roleRes[0].roleName
          ) {
            this.account.roleName = this.account.roleRes[0].roleName // 角色
          }
          if (!this.account.qq) {
            this.account.qq = ''
          }
          if (!this.account.school) {
            this.account.school = this.account.ScoolName
          }
          if (!this.account.major) {
            this.account.major = this.account.Major
          }
        }
      })
    },
    // 个人信息保存
    personInfoSave() {
      let patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im
      if (
        /[\u4e00-\u9fa5]/.test(this.account.qq) ||
        /[a-zA-Z]/.test(this.account.qq) ||
        patrn.test(this.account.qq)
      ) {
        return this.$message({
          message: '请输入正确的QQ',
          type: 'error',
          duration: 2000,
        })
      }
      let account = this.account,
        data = {
          major: account.major || '',
          nickName: account.nickName || '',
          qq: account.qq.toString() || '',
          realName: account.realName || '',
          resume: account.resume || '',
          school: account.school || '',
          sex: account.sex.toString(),
          tenantId: this.tenantId,
        }

      if (!account.realName) {
        return this.$message.error('请输入真实姓名, 必填项 !')
      }

      ACCOUNTSRTTING.updateUserInfo(data).then((res) => {
        if (res.isSuccess) {
          this.$message({
            message: '更新信息成功',
            type: 'success',
            duration: 2000,
          })
          this.getUser()
        } else {
          return this.$message({
            message: res.returnMsg,
            type: 'error',
            duration: 2000,
          })
        }
      })
    },
    // 更新信息保存，现在学校和专业无法进行修改
    // flag 为数据属性名
    moreInfoSave(flag) {
      // realName 用户名
      // ScoolName：学校
      // school：学校id
      // Major：专业
      //major :专业id
      // IsPublic: 欠缺所有人可见
      let { realName, ScoolName, Major, school, major } = this.account,
        // data = { ScoolName };
        data = { realName, ScoolName, Major, school, major }

      let account = this.account
      // debugger;
      //   data = {};
      // data[flag] = account[flag];
    },
    // 表单
    // reset
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 弹窗
    // 激活弹窗
    activePopup(flag) {
      this.popupActive = flag
      // 初始化
      if (flag) {
        if (this[flag + 'PopupReset']) {
          this[flag + 'PopupReset']()
        }
      }
    },
    //验证密码强度
    varifyPassSet(val) {
      let pass = this.passwordForm.pass.trim(),
        len = pass.length,
        reg_pass_1 = /^[\da-zA-Z._~!@#$^&*]{8,20}$/, //含有字母、数字、字符中的1种
        reg_pass_2 = /^(?![\d]+$)(?![a-zA-Z]+$)(?![!#$%^&*]+$)[\da-zA-Z._~!@#$^&*]{8,20}$/, //含有字母、数字、特殊字符中的2种以上的
        reg_pass_3 = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[._~!@#$^&*])[0-9a-zA-Z._~!@#$^&*]{8,20}$/ //含有字母、数字、特殊字符中的3种
      // debugger;
      if (!reg_pass_1.test(pass)) {
        this.passStatus = null
      } else if (reg_pass_1.test(pass) && !reg_pass_2.test(pass)) {
        this.passStatus = 'weak'
      } else if (reg_pass_2.test(pass) && !reg_pass_3.test(pass)) {
        this.passStatus = 'medium'
      } else if (reg_pass_3.test(pass)) {
        this.passStatus = 'strong'
      }
      // if()
    },
    // 关闭和取消
    cancelPopup(flag) {
      this.popupActive = ''
      this.passStatus = null
      // 清除验证码时间
      // this.codeText = null;
      // clearInterval(this.codeTime);
      // 重置表单
      if (flag && flag.indexOf('Form') > -1) {
        this.resetForm[flag]
      }
    },
    // 确认密码设置
    submitSetting() {
      // TODO:
      // type=2 query 参数类型
      // oldPassword 旧密码
      // newPassword  新密码
      // repeatPassword  确认新密码

      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          let passwordForm = this.passwordForm,
            // type = 1,
            data = {
              // UserId: this.account.UserId,
              oldPassword: passwordForm.jpass, // 旧密码
              newPassword: passwordForm.pass, // 新密码
              repeatPassword: passwordForm.checkPass, // 确认新密码
            }

          ACCOUNTSRTTING.updatePassword(data).then((result) => {
            if (result.isSuccess) {
              this.cancelPopup('passwordForm')
              this.$message({
                message: '设置成功',
                type: 'success',
                duration: 2000,
              })
              // TODO:退出登录
              setTimeout(() => {
                this.quitLogin()
              }, 1000)
            } else {
              this.$message({
                message: result.returnMsg,
                type: 'error',
                duration: 2000,
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 获取验证码
    onGetCode() {
      let mobile = this.telEmailForm.mobile
      if (!/^1[3|4|5|7|8][0-9]\d{8}$/.test(mobile)) {
        return this.$message({
          message: '请输入正确的手机号',
          type: 'error',
          duration: 2000,
        })
      }
      let data = {
        mobileNum: mobile, // 手机号
        operationFlag: 4, // 操作标识:1.注册 2.忘记密码 3.登录 4.绑定手机号 5.验证
      }
      ACCOUNTSRTTING.sendMobileCode(data).then((result) => {
        if (result.isSuccess) {
          this.$message({
            message: '发送验证码成功',
            type: 'success',
            duration: 2000,
          })
          this.codeText = 60
          this.codeTime = setInterval(() => {
            this.codeText--
            if (this.codeText === 0) {
              clearInterval(this.codeTime)
            }
          }, 1000)
        } else {
          this.$message({
            message: result.returnMsg,
            type: 'error',
            duration: 2000,
          })
        }
      })
    },
    // 手机、邮箱绑定处理
    telEmailBind(propName, hasInfo) {
      // 如果数据已经存在，则删除
      if (hasInfo) {
        let account = JSON.parse(JSON.stringify(this.account)),
          data = {},
          msg = '解除绑定'

        data[propName] = '*'

        // TODO:弹窗确认
        if (propName === 'mobile') {
          this.popupActive = propName
          account[propName] = ''
          // this.telEmailForm.mobile = this.account.mobile // 原手机号
        } else {
          // 解绑邮箱
          let data = {
            email: '',
          }
          ACCOUNTSRTTING.bindEmail(data).then((result) => {
            if (result.isSuccess) {
              this.$message({
                message: '邮箱解除绑定',
                type: 'info',
                duration: 2000,
              })
              this.getUser()
              // 本地数据功能更新
              account[propName] = ''
              this.account = account
            }
          })
        }
      } else {
        // TODO:弹窗添加
        this.popupActive = propName
      }
    },
    submitBinding(val) {
      this.$refs.telEmailForm.validate((valid) => {
        if (valid) {
          if (val === 'mobile') {
            // 绑定手机
            let data = {
              mobile: this.telEmailForm.mobile, // 更换的手机号
              // mobilePhoneNumber: this.telEmailForm.mobile, // 手机号
              // mobilePhoneNumber: this.telEmailForm.newMobile, // 新手机号
              // captcha: this.telEmailForm.code, // 短信验证码
            }
            ACCOUNTSRTTING.bindMobilePhone(data).then((result) => {
              if (result.isSuccess) {
                this.$message.success('手机绑定成功')
                this.getUser()
                this.codeText = null
                clearInterval(this.codeTime)
                this.telEmailForm.mobile = ''
                // this.telEmailForm.newMobile = ''
                this.telEmailForm.code = ''
                // 更新本地数据
                this.account[this.popupActive] = this.telEmailForm[
                  this.popupActive
                ]
                // 初始化弹窗和数据
                this.popupActive = ''
                this.telEmailForm[this.popupActive] = ''
              } else {
                this.$message.error(result.returnMsg)
              }
            })
          } else {
            // 绑定邮箱
            let data = {
              email: this.telEmailForm.email,
            }
            ACCOUNTSRTTING.bindEmail(data).then((result) => {
              if (result.isSuccess) {
                this.$message.success('邮箱绑定成功')
                this.getUser()
                // 更新本地数据
                this.account[this.popupActive] = this.telEmailForm[
                  this.popupActive
                ]
                // 初始化弹窗和数据
                this.popupActive = ''
                this.telEmailForm[this.popupActive] = ''
              }
            })
          }
          // data[this.popupActive] = this.telEmailForm[this.popupActive];
        }
      })
    },
    // 上传头像激活
    uploadAvatarActive() {
      let inputNode = this.inputFileVirtual(() => this.activePopup('avatar'))
      inputNode.click()
    },
    // 头像上传
    submitAvater() {
      // 实例化
      let formdata = new FormData(),
        block = this.avatar.image.split(';'), // 分割
        contentType = block[0].split(':')[1], // 文件类型
        b64Data = block[1].split(',')[1], // base64 数据
        fileName = this.avatar.file.name,
        fileAfterTransfor = null;

      // 转换
      fileAfterTransfor = this.base64toBlob(b64Data, contentType)
      formdata.append('file', fileAfterTransfor, fileName)
      // formdata.append('file', this.avatar.file, fileName) // file文件格式
      COMMON.UploadFile(formdata).then((result) => {
        if (result.returnCode === 200) {
          let data = {
            photoUrl: result.data.url,
          }
          ACCOUNTSRTTING.uploadUserPhoto(data).then((res) => {
            if (res.returnCode === 200) {
              // 更新页面数据
              this.getUser()

              // 更新 sessionLocalstorage、更新 Vuex
              setTimeout(() => {
                this.$store.commit('accountInfo', this.account)
                // let userInfo = JSON.parse(sessionStorage.UserInfo)
                // userInfo.UserImgUrl = this.account.photo
                // sessionStorage.UserInfo = JSON.stringify(userInfo)
              }, 1000)

              // 关闭弹窗
              this.cancelPopup()
            }
          })
        } else {
          this.$message({
            message: result.returnMsg,
            type: 'error',
            duration: 2000,
          })
        }
      })
    },
    // 剪切操作
    crop() {
      const { coordinates, canvas } = this.$refs.cropper.getResult()
      if (coordinates && canvas) {
        this.avatar.coordinates = coordinates
        this.avatar.image = canvas.toDataURL()
      }
    },
    // 虚拟 input 上传
    inputFileVirtual(addToChangeMethod) {
      // 1.创建一个上传节点
      let inputNode = document.createElement('input'),
        self = this

      // 文件上传按钮配置
      inputNode.setAttribute('type', 'file')
      inputNode.setAttribute("accept", "image/jpeg, image/jpg"); // 限制图片除外的文件上传
      // 文件上传过程
      inputNode.onchange = function uploadImg(evt) {
        let list,
          formatPass = true

        // 文件装配
        let fileList = evt.target.files
        list = Array.from(fileList)

        // 如果存在不是 image/jpeg 格式的图片就会触发停止上传的操作
        // jpg/jpeg 是一样，同属于 image/jpeg 格式
        formatPass = self.$util.filesFormatCheck(list, 'jpg|jpeg')
        if (formatPass) {
          return self.$message.error('上传失败，只允许上传 jpg/jpeg 格式图片！')
        }

        let fullscreenLoading = self.$loading({
          lock: true,
          text: `图片上传中请稍等...`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 获取 file
        let file = fileList[0];
        let reader = new FileReader();

        let formdata = new FormData();
        list.forEach((file) => {
          formdata.append('file', file, file.name)
        })
        COMMON.UploadMultipleFile(formdata).then((result) => {
          if (result.returnCode == 200) {
            let dataList = JSON.parse(JSON.stringify(result.data));
            let imgList = [];
            dataList.forEach((item, index) => {
              // 图片格式大小尺寸区间
              if (item.size && item.size > 1048576) {
                setTimeout(() => {
                  self.$message.error(`上传失败，图片名称为${item.fileName}格式过大！`);
                }, index*5);
              } else {
                imgList.push(item);
              }
            });

            if (imgList.length === 0) {
              return fullscreenLoading.close(); // 关闭Loading
            }
            // 校验图片jpg|jpeg
            self.verifyImgs(imgList).then(res => {
              if (res.correct && res.correct.length) {
                reader.onload = (e) => {
                  self.avatar.url = e.target.result
                }
                reader.readAsDataURL(file)
                self.avatar.file = file
                // self.avatar.url = window.URL.createObjectURL(file);

                if (addToChangeMethod) {
                  addToChangeMethod()
                }
              }
            })
          }
          fullscreenLoading.close(); // 关闭Loading
        }).catch(err => {
          console.log('error', err)
          fullscreenLoading.close(); // 关闭Loading
        });
      }

      return inputNode
    },

    // base64 转换成 Bolb 实现上传处理
    base64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ''
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      var blob = new Blob(byteArrays, {
        type: contentType,
      })
      return blob
    },
    // 退出登录
    quitLogin() {
      sessionStorage.setItem('hasLogin', '') //null,false,'',
      sessionStorage.setItem('UserInfo', '') //null,false,'',
      sessionStorage.setItem('accountInfo', '') //null,false,'',
      this.$store.commit('accountInfo', 'false')
      this.$store.commit('userStatus', 'false')
      this.$router.push('/')
    },
  },
}
</script>
<style lang="scss" scoped>
.account-setting {
  background-color: #f2f5fc;
  background-size: cover;
  background-position: center;
  padding-top: 80px;
}
.account-center {
  width: 1200px;
  padding-top: 40px;
  padding-bottom: 50px;
  margin: 0 auto;
}
.box {
  padding: 50px;
  background: #fff;
}
.account-block {
  box-shadow: 0 2px 10px 0 #e3e4e6;
  margin-bottom: 10px;
  .title {
    overflow: hidden;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color: #333;
    border-bottom: 1px solid #e6e9f2;
    background-color: #fff;
    font-weight: normal;
    i {
      position: relative;
      top: 3px;
      margin: 0 9px 0 20px;
      display: inline-block;
      width: 4px;
      height: 17px;
      background: #4c88ff;
    }
    .box {
      padding: 0 50px;
    }
    .see {
      float: right;
      margin-right: 50px;
      text-align: left;
      line-height: 50px;
      font-size: 14px;
      color: #333;
    }
  }
}
.data-left {
  float: left;
  width: 310px;
  height: 340px;
  border-right: 1px solid #e6e9f2;
  color: #999;
  box-sizing: border-box;
  text-align: center;
  .avatar {
    overflow: hidden;
    width: 140px;
    height: 140px;
    margin: 0 auto 40px;
    border-radius: 50%;
    text-align: center;
    line-height: 140px;
    cursor: pointer;
  }
  img {
    width: 100%;
    // height: 100%;
  }
  p {
    font-size: 14px;
    text-indent: 20px;
  }
}

.data-right {
  float: right;
  width: 790px;
  height: 340px;
  &::v-deep .el-form-item__label {
    text-align: left;
    text-indent: 50px;
  }
  .el-form-item {
    margin-bottom: 18px;
  }
  .marginBottom {
    margin-top: -10px;
    margin-bottom: 10px;
    span {
      color: #606266;
    }
  }
}

.data-right,
.more-information {
  &::v-deep {
    .el-input__count {
      line-height: 1;
    }
    .el-input__inner,
    .el-textarea__inner {
      position: relative;
      font-family: sans-serif;
      resize: none;
    }
    .el-input .el-input__count {
      position: absolute;
      top: 70%;
      right: 0.8em;
    }
    .el-input__count {
      position: absolute;
      right: 17px;
      bottom: -15px;
      padding: 0 0px;
    }
  }
}

.clearfix:after {
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
  content: '';
}
.function {
  width: 100%;
  &::v-deep .el-button {
    float: right;
    margin-top: 10px;
  }
  &::v-deep .el-checkbox__inner {
    width: 20px;
    height: 20px;
    margin-left: 70px;
    margin-right: 12px;
  }
  &::v-deep .el-checkbox__inner::after {
    width: 6px;
    height: 9px;
    left: 6px;
    top: 2px;
  }
}
.account {
  li {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #e6e9f2;
    label {
      font-size: 16px;
      color: #333;
    }
    span {
      font-size: 14px;
      color: #999;
      &.binding {
        color: #09b54a;
      }
    }
    &::v-deep .el-button {
      height: 40px;
      margin-top: 16px;
    }
  }
}
// 弹窗
.popup-password {
  &::v-deep {
    .popup-inner {
      height: 400px !important;
    }
  }
  &.off {
    display: none;
  }
  .password-form {
    margin-top: 40px;
    .pass-show-wrap {
      width: 100%;
      display: flex;
      justify-content: start;
      align-content: center;
      margin: 20px 0;
      padding: 10px 0px;
      background: #efefef;
      span {
        margin-left: 10px;
        width: 90px;
        height: 20px;
        background: #fff;
        transition: background 0.5s;
        &.weak,
        &.medium,
        &.strong {
          background: #5bba48;
        }
      }
      p {
        margin-left: 10px;
        height: 20px;
        line-height: 20px;
      }
    }
  }
}
.popup-tel-mobile {
  ::v-deep.popup-inner {
    height: 280px;
    // height: 350px;
  }
  &.off {
    display: none;
  }
  .tel-email-form {
    margin-top: 40px;
    .mobile-input {
      width: 240px;
      margin-right: 5px;
    }
    .el-button {
      width: 75px;
      height: 40px;
      padding: 0 5px;
    }
  }
}
.popup-tel-email {
  ::v-deep.popup-inner {
    height: 220px;
  }
  &.off {
    display: none;
  }
  .tel-email-form {
    margin-top: 40px;
  }
}

.popup-avatar {
  &::v-deep {
    .popup-inner {
      width: 550px !important;
      height: 500px !important;
    }
  }
  &.off {
    display: none;
  }
  .crop-wrap {
    overflow: hidden;
    margin-top: 40px;
  }
  .cropper-box {
    float: left;
    width: 300px;
    .cropper {
      height: 300px;
      background-color: rgba(65, 89, 138, 0.3);
      &::v-deep img {
        max-width: unset !important;
        max-height: unset !important;
      }
    }
  }
  .preview {
    overflow: hidden;
    float: right;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background-color: rgba(65, 89, 138, 0.3);
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
